
import TransportationPermission from '@/components/Passenger/models/TransportationPermission';
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class BookingPtpSelect extends Vue {
  selectedItemId: number | null = null;
  selectedItem: TransportationPermission | null = null;

  @Prop({ default: () => [] }) permissions: TransportationPermission[];
  @Prop({ required: true }) value: TransportationPermission | null;

  @Watch('value', { immediate: true }) onValueChanged() {
    this.selectedItem = null;
    this.selectedItemId = null;
    if (this.value) {
      this.selectedItem = this.value;
      this.selectedItemId = this.selectedItem.id;
    }
  }

  selectPermission(permission: any) {
    this.selectedItem = permission;
    this.$emit('input', this.selectedItem);
  }
}
